import React from 'react'
import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Button from 'base-components/Button'

export interface Props {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  currentPasswordVal: string
  newPasswordVal: string
  repeatedPasswordVal: string
}

const PasswordChanger: React.FC<Props> = ({
  onChange,
  onSubmit,
  currentPasswordVal,
  newPasswordVal,
  repeatedPasswordVal,
}) => {
  const { t } = useTranslation()
  const disabled =
    !currentPasswordVal || !newPasswordVal || !repeatedPasswordVal
  return (
    <form onSubmit={onSubmit} className="max-w-sm">
      <div className="font-semibold">{t('general.changePassword')}</div>

      <TextField
        name="currentPassword"
        type="password"
        label={t('PasswordChanger.currentPassword')}
        onChange={onChange}
        value={currentPasswordVal}
        className="w-auto! sm:w-[95%]! min-w-[230px]"
      />

      <TextField
        name="newPassword"
        type="password"
        label={t('PasswordChanger.newPassword')}
        onChange={onChange}
        value={newPasswordVal}
        className="w-auto! sm:w-[95%]! min-w-[230px]"
      />

      <TextField
        name="repeatedPassword"
        type="password"
        label={t('PasswordChanger.repeatedPassword')}
        onChange={onChange}
        value={repeatedPasswordVal}
        className="w-auto! sm:w-[95%]! min-w-[230px]"
      />
      <div className="mt-4">
        <Button type="submit" disabled={disabled}>{t('general.save')}</Button>
      </div>
    </form>
  )
}

export default PasswordChanger
